import { ReactElement, useEffect } from 'react';
import { UISubNav, useUINav } from '@/ui';
import { GeneralCompanySettingsSection } from '@/companies/components';
import { useCompanyContext } from '@/companies/providers';
import { useCompanyPermissions } from '@/companies/hooks';
import { usePagesTranslation } from '../hooks';
import { Navigate } from 'react-router';

export function GeneralSettingsPage(): ReactElement {
    const { t } = usePagesTranslation();
    const { setParts } = useUINav();
    useEffect(() => {
        setParts([
            {
                text: t('shared.labels.settings')
            },
            { text: t('shared.labels.general') }
        ]);
    }, [setParts, t]);

    const { company } = useCompanyContext();
    const { canViewGeneralSettings } = useCompanyPermissions();
    if (!canViewGeneralSettings) {
        return <Navigate to="/" replace />;
    }

    return (
        <div
            style={{
                display: 'flex',
                flex: 1,
                flexDirection: 'column',
                padding: 32,
                gap: 24
            }}
        >
            <UISubNav title={t('shared.labels.general_settings')} />
            <GeneralCompanySettingsSection company={company} />
        </div>
    );
}
